@for (group of groups(); track group.kind) {
  <section class="employee-basket-card employee-basket-prior-year-payments">
    <mat-expansion-panel class="employee-basket-prior-year-payments__panel" [expanded]="true">
      <mat-expansion-panel-header>
        <mat-panel-title class="employee-basket-prior-year-payments__header">
          <mat-icon
            class="employee-basket-prior-year-payments__icon"
            [style.color]="group.statusColor"
            [svgIcon]="group.icon"
          >
          </mat-icon>
          <span class="employee-basket-prior-year-payments__title">
            {{ 'employee.basket.prior-year-payments' | translate }}
          </span>
          <span
            class="employee-basket-prior-year-payments__count"
            [style.background-color]="group.countBackgroundColor"
            [style.color]="group.countTextColor"
          >
            {{ group.benefits.length }}
          </span>
          <span
            class="employee-basket-prior-year-payments__status"
            [style.color]="group.statusColor"
          >
            {{ group.statusKey | translate | uppercase }}
          </span>
        </mat-panel-title>
      </mat-expansion-panel-header>

      @for (benefit of group.benefits; track benefit.id) {
        <div class="employee-basket-prior-year-payments__row">
          <div class="employee-basket-prior-year-payments__info">
            <span class="employee-basket-prior-year-payments__benefit-name">
              {{ benefit.name | translate }}
            </span>
            <flexyoo-employee-financing-plan-badge
              [pbGrossAmount]="benefit.pbGrossAmount"
              [ssGrossAmount]="benefit.ssPeriodBudget"
            />
          </div>
          <span class="employee-basket-prior-year-payments__amount">
            {{ benefit.yearlyGrossPrice | flexyooNumber }}
          </span>
        </div>
      }
    </mat-expansion-panel>
  </section>
}
